import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

function Navigation({ activeSection }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const handleNavClick = (e, href, sectionId) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      scrollToSection(sectionId || href.substring(1));
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="logo">
          <img src="/logo.png" alt="Diba Mizan" className="logo-img" />
        </Link>
        
        <div className={`nav-links ${mobileMenuOpen ? 'open' : ''}`}>
          {location.pathname === '/' ? (
            <>
              <a 
                href="#home" 
                className={activeSection === 'home' ? 'active' : ''}
                onClick={(e) => handleNavClick(e, '#home', 'home')}
              >
                Home
              </a>
              <a 
                href="#about" 
                className={activeSection === 'about' ? 'active' : ''}
                onClick={(e) => handleNavClick(e, '#about', 'about')}
              >
                About
              </a>
              <a 
                href="#portfolio" 
                className={activeSection === 'portfolio' ? 'active' : ''}
                onClick={(e) => handleNavClick(e, '#portfolio', 'portfolio')}
              >
                Portfolio
              </a>
              <a 
                href="#contact" 
                className={activeSection === 'contact' ? 'active' : ''}
                onClick={(e) => handleNavClick(e, '#contact', 'contact')}
              >
                Contact
              </a>
            </>
          ) : (
            <>
              <Link to="/#home">Home</Link>
              <Link to="/#about">About</Link>
              <Link to="/#portfolio">Portfolio</Link>
              <Link to="/#contact">Contact</Link>
            </>
          )}
          <Link 
            to="/portfolio-viewer"
            className={location.pathname === '/portfolio-viewer' ? 'active' : ''}
          >
            PDF Portfolio
          </Link>
        </div>

        <div 
          className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;

